"use strict";

// Keeping this here, in case we ever need to add any infrastructure code
module.exports = function(angular, moduleName) {
  angular
    .module(moduleName)
    .service(
      "menuItemRepository",
      require("app/infrastructure/repositories/menuItemRepository")
    )
    .service(
      "openFinWebClientApiFactory",
      require("app/infrastructure/factories/openFinWebClientApiFactory")
    )
    .value(
      "openFinWebClientFeatures",
      require("app/infrastructure/openFinWebClientFeatures")
    )
    .service(
      "OpenfinWindowFactory",
      require("app/infrastructure/factories/OpenfinWindowFactory")
    )
    .service(
      "openFinWindowUtils",
      require("app/infrastructure/utils/openFinWindowUtils")
    )
    .service(
      "RediWindowService",
      require("app/infrastructure/RediWindowService")
    )
    .factory("RediWindow", require("app/infrastructure/models/RediWindow"))
    .service(
      "RediWindowRepository",
      require("app/infrastructure/repositories/RediWindowRepository")
    )
    .service(
      "RediWindowFactory",
      require("app/infrastructure/factories/RediWindowFactory")
    )
    .service(
      "RediWindowInstanceInitializer",
      require("app/infrastructure/RediWindowInstanceInitializer")
    )
    .service(
      "RediPlusWindowRepository",
      require("app/infrastructure/repositories/RediPlusWindowRepository")
    )
    .service(
      "eikonLightInstaller",
      require("app/infrastructure/eikonLightInstaller")
    )
    .service(
      "eikonLightLauncher",
      require("app/infrastructure/eikonLightLauncher")
    )
    .service("eikonUsageCheck", require("app/infrastructure/eikonUsageCheck"))
    .service(
      "roccUsageRepository",
      require("app/infrastructure/roccUsageRepository")
    )
    .service(
      "sideBySideRequestGateway",
      require("app/infrastructure/sideBySideRequestGateway")
    )
    .service("sideBySideApi", require("app/infrastructure/sideBySideApi"))
    .service(
      "sideBySideMessageHandler",
      require("app/infrastructure/sideBySideMessageHandler")
    )
    .service(
      "sideBySideCommandFactory",
      require("app/infrastructure/factories/sideBySideCommandFactory")
    )
    .service(
      "sideBySideLinkTypeFactory",
      require("app/infrastructure/factories/sideBySideLinkTypeFactory")
    )
    .service(
      "sideBySideSessionRepository",
      require("app/infrastructure/repositories/sideBySideSessionRepository")
    );
};



// WEBPACK FOOTER //
// ./app/infrastructure/index.js